type ValueType = number | string | object | null | boolean

export const setSessionStorage = (name: string, value: ValueType) => {
  let valueString: string = JSON.stringify(value)
  sessionStorage.setItem(name, valueString)
}

export const getSessionStorage = (name: string) => {
  let resultString: string | null = sessionStorage.getItem(name)
  if (resultString === null) {
    return null
  }

  return JSON.parse(resultString)
}

export const removeSessionStorage = (name: string) => {
  sessionStorage.removeItem(name)
}

export const clearSessionStorage = () => {
  sessionStorage.clear()
}